import * as React from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Grid } from '@material-ui/core';
import ReactResizeDetector from 'react-resize-detector';

import * as SubscriptionSelectors from '../selectors/subscription';
import * as SubscriptionActions from '../actions/subscription';
import * as ChangeTypePaymentCreator from '../creators/changeTypePayment';
import * as ExistSubscriptionActions from '../actions/existSubscription';
import * as EditEditExistSubscriptionCreator from '../creators/editExistSubscription';
import * as SubscriptionDateCreators from '../creators/subDateRange';
import * as SubscriptionCreators from '../creators/subscription';
import * as DeleteExistSubscriptionCreator from '../creators/patchSubscription';
import * as EditExistSubscriptionCreator from '../creators/putSubscription';
import * as ToasterActions from '../actions/subToaster';

import * as Const from '../constants';

import SubscriptionAdd from '../components/SubscriptionAdd/SubscriptionAdd';
import ExistSubscriptionList from '../components/ExistSubscription/ExistSubscriptionList';
import SnackTokenAlert from '../components/TokenInvalidAlert/SnackTokenAlert';

import '../style.scss';

import State from '../../../interfaces/states/State';

import AvailablePackage from '../interfaces/AvailablePackage';
import ExistSubscription from '../interfaces/ExistSubscription';
import Validated from '../interfaces/Validated';
import Message from '../interfaces/Message';

import { GridSize } from '@material-ui/core/es/Grid';
import { SubscriptionPeriod } from 'components/constants';

interface DispatchProps {
  clearForm: () => void;
  changeProduct: (product: string) => void;
  changePackage: (package_: string) => void;
  changeDateTo: (date: Date) => void;
  changeDateFrom: (id: number) => void;
  changeTypePayment: (value: string) => void;
  changePlanePrice: (value: string | number) => void;
  changeFieldsArea: (fields: string) => void;
  changeSubscriptionPeriod: (period: SubscriptionPeriod) => void;
  changeShouldCreatePayment: (value: boolean) => void;
  changeFormStatus: (status: boolean) => void;
  fetchSubscriptionDataForm: () => void;
  sendSubscriptionForm: () => void;
  fetchExistUserSubscription: () => void;
  deleteExistSubscription: (id: number) => void;
  editExistSubscription: (id: number) => void;
  editExistSubId: (id: number) => void;
  editExistSubDatetimeFinish: (id: number) => void;
  editExistSubWidth: (width: number) => void;
  removeMessage: (id: string) => void;
}

interface OwnProps {
  open: boolean;
  product: string;
  package_: string;
  dateTo: Date;
  dateFrom: Date;
  subscriptionPeriod: SubscriptionPeriod;
  shouldCreatePayment: boolean;
  dateError: string;
  typePayment: string;
  planePrice: string | number;
  availableProduct: string[];
  availablePackage: AvailablePackage[];
  sendingFormError: string;
  isSendingForm: boolean;
  existSubscription: ExistSubscription[];
  existSubscriptionLoading: boolean;
  editExistSubDatetimeFinishValue: Date;
  isUserColumnMdSize: boolean;
  subscriptionColumnSize: GridSize;
  validatedForm: Validated;
  messages: Message[];
  isTokenUpdated: boolean;
  onClose: () => void;
  fieldsArea: number;
}

interface Props extends DispatchProps, OwnProps {}

class PaymentsSubscription extends React.PureComponent<Props> {

  componentDidUpdate (prevProps) {
    if (!prevProps.open && this.props.open) {
      this.props.fetchSubscriptionDataForm();
      this.props.fetchExistUserSubscription();
    }
  }

  handleChangeProduct = e => {
    this.props.changeProduct(e.value);
    this.props.changePackage(null);
  };

  handleChangePackage = e => {
    this.props.changePackage(e.value);
  };

  handleChangeTypePayment = e => {
    this.props.changeTypePayment(e.value);
  };

  handleChangePlanePrice = e => {
    this.props.changePlanePrice(e.target.value);
  };

  handleChangeFieldsArea = e => {
    this.props.changeFieldsArea(e.target.value);
  };

  handleSubmit = () => {
    this.props.sendSubscriptionForm();
    this.props.clearForm();
  };

  handleCansel = () => {
    this.props.clearForm();
    this.props.onClose();
  };

  handleResize = (): void => {
    this.props.editExistSubWidth(document.body.clientWidth);
  };

  setSubscriptionPeriod = (period: SubscriptionPeriod): void => {
    this.props.changeSubscriptionPeriod(period);
  };

  setShouldCreatePayment = (value: boolean): void => {
    this.props.changeShouldCreatePayment(value);
  };

  render () {
    const {
      open,
      onClose,
      product,
      package_,
      dateFrom,
      dateTo,
      subscriptionPeriod,
      shouldCreatePayment,
      typePayment,
      planePrice,
      fieldsArea,
      dateError,
      availablePackage,
      availableProduct,
      sendingFormError,
      isSendingForm,
      existSubscription,
      deleteExistSubscription,
      existSubscriptionLoading,
      editExistSubscription,
      editExistSubDatetimeFinish,
      editExistSubId,
      editExistSubDatetimeFinishValue,
      clearForm,
      changeDateTo,
      changeDateFrom,
      fetchExistUserSubscription,
      isUserColumnMdSize,
      subscriptionColumnSize,
      validatedForm,
      messages,
      removeMessage,
      isTokenUpdated,
    } = this.props;

    const { isFormReady, formRender } = validatedForm;

    const isFieldsAreaDisabled = (product !== Const.CROP_MONITORING && product !== Const.FORESTRY);

    return (
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        aria-labelledby='form-dialog-title'>
        <DialogContent
          className='sub-dialog-content'>
          <AppBar>
            <Toolbar className='sub-dialog-toolbar'>
              <IconButton
                color='inherit'
                onClick={this.handleCansel}
                aria-label='close'>
                <CloseIcon />
              </IconButton>
              <h2 className='form-dialog-title'>
                {'User Subscriptions'}
              </h2>
            </Toolbar>
          </AppBar>
          <Grid
            className='sub-dialog-content-wrapper'
            container>
            <ReactResizeDetector
              handleWidth
              onResize={this.handleResize} />

            <SnackTokenAlert open={isTokenUpdated} />

            <Grid
              item
              lg={subscriptionColumnSize}
              md={9}
              sm={12}
            >

              <SubscriptionAdd
                handleChangeProduct={this.handleChangeProduct}
                handleChangeFieldsArea={this.handleChangeFieldsArea}
                handleChangePackage={this.handleChangePackage}
                handleChangeTypePayment={this.handleChangeTypePayment}
                handleChangePlanePrice={this.handleChangePlanePrice}
                handleSubmit={this.handleSubmit}
                handleChangeDateFrom={changeDateFrom}
                handleChangeDateTo={changeDateTo}
                subscriptionPeriod={subscriptionPeriod}
                setSubscriptionPeriod={this.setSubscriptionPeriod}
                shouldCreatePayment={shouldCreatePayment}
                setShouldCreatePayment={this.setShouldCreatePayment}
                planePrice={planePrice}
                typePayment={typePayment}
                package_={package_}
                fieldsArea={fieldsArea}
                isFieldsAreaDisabled={isFieldsAreaDisabled}
                formRender={formRender}
                dateError={dateError}
                dateFrom={dateFrom}
                dateTo={dateTo}
                product={product}
                isFormReady={isFormReady}
                availableProduct={availableProduct}
                availablePackage={availablePackage}
                clearForm={clearForm}
                sendingFormError={sendingFormError}
                isSendingForm={isSendingForm}
                messages={messages}
                removeMessage={removeMessage}
              />
            </Grid>

            <Grid
              item
              lg={subscriptionColumnSize}
              md={9}
              sm={12}
            >
              <ExistSubscriptionList
                isMdSize={isUserColumnMdSize}
                fetchExistUserSubscription={fetchExistUserSubscription}
                editExistSubId={editExistSubId}
                editExistSubDatetimeFinish={editExistSubDatetimeFinish}
                editExistSubDatetimeFinishValue={editExistSubDatetimeFinishValue}
                existSubscriptionLoading={existSubscriptionLoading}
                deleteExistSubscription={deleteExistSubscription}
                existSubscription={existSubscription}
                editExistSubscription={editExistSubscription}
              />

            </Grid>
          </Grid>

        </DialogContent>
      </Dialog>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    product: SubscriptionSelectors.product$(state),
    package_: SubscriptionSelectors.package$(state),
    dateTo: SubscriptionSelectors.dateTo$(state),
    dateFrom: SubscriptionSelectors.dateFrom$(state),
    subscriptionPeriod: SubscriptionSelectors.subscriptionPeriod$(state),
    shouldCreatePayment: SubscriptionSelectors.shouldCreatePayment$(state),
    dateError: SubscriptionSelectors.dateError$(state),
    typePayment: SubscriptionSelectors.typePayment$(state),
    planePrice: SubscriptionSelectors.planePrice$(state),
    fieldsArea: SubscriptionSelectors.fieldsArea$(state),
    isFormReady: SubscriptionSelectors.isFormReady$(state),
    availableProduct: SubscriptionSelectors.availableProduct$(state),
    availablePackage: SubscriptionSelectors.availablePackage$(state),
    sendingFormError: SubscriptionSelectors.existSubscriptionMessage$(state),
    isSendingForm : SubscriptionSelectors.isSendingForm$(state),
    existSubscription: SubscriptionSelectors.existSubscription$(state),
    existSubscriptionLoading: SubscriptionSelectors.existSubscriptionLoading$(state),
    editExistSubDatetimeFinishValue: SubscriptionSelectors.editExistSubDatetimeFinish$(state),
    subscriptionColumnSize: SubscriptionSelectors.subscriptionColumnSize$(state),
    isUserColumnMdSize: SubscriptionSelectors.isUserColumnMdSize$(state),
    validatedForm: SubscriptionSelectors.validatedForm$(state),
    messages: SubscriptionSelectors.toasterMessages$(state),
    isTokenUpdated: SubscriptionSelectors.isTokenUpdated$(state),
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    changeProduct: dispatchProps.changeProduct,
    changePackage: dispatchProps.changePackage,
    changeDateTo: dispatchProps.changeDateTo,
    changeDateFrom: dispatchProps.changeDateFrom,
    changeTypePayment: dispatchProps.changeTypePayment,
    changePlanePrice: dispatchProps.changePlanePrice,
    changeFieldsArea: dispatchProps.changeFieldsArea,
    changeSubscriptionPeriod: dispatchProps.changeSubscriptionPeriod,
    changeShouldCreatePayment: dispatchProps.changeShouldCreatePayment,
    changeFormStatus: dispatchProps.changeFormStatus,
    clearForm: dispatchProps.clearForm,
    fetchSubscriptionDataForm: dispatchProps.fetchSubscriptionDataForm,
    sendSubscriptionForm: dispatchProps.sendSubscriptionForm,
    fetchExistUserSubscription: dispatchProps.fetchExistUserSubscription,
    deleteExistSubscription: dispatchProps.deleteExistSubscription,
    editExistSubscription: dispatchProps.editExistSubscription,
    editExistSubId: dispatchProps.editExistSubId,
    editExistSubDatetimeFinish: dispatchProps.editExistSubDatetimeFinish,
    editExistSubWidth: dispatchProps.editExistSubWidth,
    removeMessage: dispatchProps.removeMessage,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    clearForm: SubscriptionActions.subFormInit,
    changeProduct: SubscriptionActions.subChangeProduct,
    changePackage: SubscriptionActions.subChangePackage,
    changeDateTo: SubscriptionDateCreators.changeSubDateTo,
    changeDateFrom: SubscriptionDateCreators.changeSubDateFrom,
    changeTypePayment: ChangeTypePaymentCreator.default,
    changePlanePrice: SubscriptionActions.subChangePlanePrice,
    changeFieldsArea: SubscriptionActions.subChangeFieldsArea,
    changeSubscriptionPeriod: SubscriptionActions.subChangeSubscriptionPeriod,
    changeShouldCreatePayment: SubscriptionActions.subChangeShouldCreatePayment,
    changeFormStatus: SubscriptionActions.subChangeFormStatus,
    fetchSubscriptionDataForm: SubscriptionCreators.fetchSubscriptionDataForm,
    sendSubscriptionForm: SubscriptionCreators.sendSubscriptionForm,
    fetchExistUserSubscription: SubscriptionCreators.fetchExistUserSubscription,
    deleteExistSubscription: DeleteExistSubscriptionCreator.default,
    editExistSubscription: EditExistSubscriptionCreator.default,
    editExistSubId: EditEditExistSubscriptionCreator.default,
    editExistSubDatetimeFinish: ExistSubscriptionActions.editExistSubDatetimeFinish,
    editExistSubWidth: ExistSubscriptionActions.editExistSubWidth,
    removeMessage: ToasterActions.removeToasterMessage,
  }, mergeProps
)(PaymentsSubscription);
